module.exports = __webpack_public_path__ + "img/bell.42a2c029.svg";